require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./chaire-unesco-0-9-4.json") })
        }
      }, "path---chaire-unesco-0-9-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---chaire-unesco-0-9-4!./.cache/json/chaire-unesco-0-9-4.json
// module id = 366
// module chunks = 231608221292675